import { useEffect } from 'react';

const useNoScroll = (isOpen:boolean) => {
  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("no-scroll");
    } else {
      document.documentElement.classList.remove("no-scroll");
    }
    return () => {
      document.documentElement.classList.remove("no-scroll");
    };
  }, [isOpen]); 
};

export default useNoScroll;
